export const formatBytes = (bytes, decimalPlace = 2, unit = 1024) => {
  if (!+bytes) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const decimal = decimalPlace < 0 ? 0 : decimalPlace;
  const exponent = Math.floor(Math.log(bytes) / Math.log(unit));

  return `${parseFloat((bytes / Math.pow(unit, exponent)).toFixed(decimal))} ${
    units[exponent]
  }`;
};

export const convertBytes = (bytes, unit, decimalPlace = 2) => {
  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const exponent = units.indexOf(unit);

  return (bytes / Math.pow(1024, exponent)).toFixed(decimalPlace);
};
